import axios from 'axios'
import { CRM_API_URL } from '@/constants/api'

function open (filialId) {
    return axios.post(`${CRM_API_URL}/administrator/fiscal-shift/open`, null, { params: { filialId } }).then(response => response.data)
}

function close (filialId, data = {}) {
    return axios.post(`${CRM_API_URL}/administrator/fiscal-shift/close`, data, { params: { filialId } }).then(response => response.data)
}

function fetchStatus (filialId) {
    return axios.get(`${CRM_API_URL}/administrator/fiscal-shift/status`, { params: { filialId } }).then(response => response.data)
}

function sync (filialId) {
    return axios.post(`${CRM_API_URL}/administrator/fiscal-shift/sync`, null, { params: { filialId } }).then(response => response.data)
}

export default { open, close, fetchStatus, sync }
